<template>
  <div id="Login">
    <div class="modal-invisible">
      <div id="LoadingForm" v-if="display_form == 'loading'">
        <div id="loading_box" class="box">
          <LoadingSpinner />
        </div>
      </div>
      <div id="LoginForm" v-if="display_form == 'login'">
        <div id="main_logo">
          <img :src="logo" alt="Shambhala Music Festival" />
        </div>
        <NotificationBanner/>
        <div id="login_box" class="box">
          <h2>User Login</h2>
          <div id="LoginBox">
            <form @submit="Login" autocomplete="off">
              <div
                v-if="message_display != false && message_content != ''"
                v-bind:class="`msg msg-${message_display}`"
              >
                <strong>{{ message_display.capitalize() }}: </strong
                >{{ message_content }}
              </div>
              <div>
                <input
                  v-model="email"
                  type="email"
                  placeholder="Email Address"
                  autocomplete="off"
                  v-on:focus="ClearMessages"
                />
              </div>
              <div>
                <input
                  v-model="password"
                  type="password"
                  placeholder="Password"
                  autocomplete="off"
                  v-on:focus="ClearMessages"
                />
              </div>
              <div class="login-submit"><button>Login</button></div>
              <div class="login-forgot">
                <a href="#" v-on:click="ShowForgot">Reset Password</a>
              </div>
            </form>
          </div>
        </div>
        <div class="transparent-box">
          <p>
            You have an account if you bought tickets or ShambhaLodging through
            our website for the festival or received a transfer from someone who
            has. If you do not know your password please use the
            <a href="#" v-on:click="ShowForgot" class="emphasize"
              >Reset Password</a
            >
            feature.
          </p>
          <p>
            Please email us at
            <a href="mailto:sales@shambhalamusicfestival.com" class="emphasize"
              >sales@shambhalamusicfestival.com</a
            >
            if you bought a ticket and/or Shambhalodging package but are
            experiencing problems logging in.
          </p>
        </div>
      </div>
      <div id="ForgotPasswordForm" v-if="display_form == 'forgot'">
        <div id="main_logo">
          <img :src="logo" alt="Shambhala Music Festival" />
        </div>
        <NotificationBanner/>
        <div id="forgot_box" class="box">
          <h2>Reset Password?</h2>
          <div id="ForgotBox">
            <form @submit="Forgot" autocomplete="off">
              <div
                v-if="message_display != false && message_content != ''"
                v-bind:class="`msg msg-${message_display}`"
                v-html="
                  `<strong>${message_display.capitalize()}: </strong>${message_content}`
                "
              ></div>
              <div>
                <input
                  v-model="email"
                  type="email"
                  placeholder="Email Address"
                  autocomplete="off"
                  required="required"
                  v-on:focus="ClearMessages"
                />
              </div>
              <div class="forgot-submit">
                &nbsp; <button :disabled="is_sending_reset">Email Reset Link</button>
                <button onclick="window.location = '/';" class="button-no">
                  <i class="fas fa-times"></i> Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="transparent-box">
          <p>
            Please email us at
            <a href="mailto:sales@shambhalamusicfestival.com" class="emphasize"
              >sales@shambhalamusicfestival.com</a
            >
            if you bought a ticket and/or Shambhalodging package but are
            experiencing problems logging in.
          </p>
        </div>
      </div>
      <div id="ResetPasswordForm" v-if="display_form == 'reset'">
        <div id="main_logo">
          <img :src="logo" alt="Shambhala Music Festival" />
        </div>
        <div id="forgot_box" class="box">
          <h2>Password Reset</h2>
          <div id="loading_box" v-if="!reset_password">
            <LoadingSpinner />
          </div>
          <div id="ResetBox" v-if="reset_password">
            <div
              v-if="message_display != false && message_content != ''"
              v-bind:class="`msg msg-${message_display}`"
            >
              <strong>{{ message_display.capitalize() }}: </strong
              >{{ message_content }}
            </div>
            <form @submit="ResetPassword" autocomplete="off" v-if="!was_reset">
              <div>
                <input
                  id="pwr1"
                  v-model="pwr1"
                  type="password"
                  placeholder="New Password"
                  autocomplete="off"
                  required="required"
                  v-on:focus="ClearMessages"
                />
              </div>
              <div>
                <input
                  id="pwr2"
                  v-model="pwr2"
                  type="password"
                  placeholder="Confirm Password"
                  autocomplete="off"
                  required="required"
                  v-on:focus="ClearMessages"
                />
              </div>
              <div class="forgot-submit">
                <button v-bind:disabled="forgot_password">
                  Reset Password
                </button>
              </div>
            </form>
            <div v-if="was_reset">
              <button onclick="window.location = '/';">Continue</button>
            </div>
          </div>
        </div>
        <div class="transparent-box">
          <p>
            Please email us at
            <a href="mailto:sales@shambhalamusicfestival.com" class="emphasize"
              >sales@shambhalamusicfestival.com</a
            >
            if you bought a ticket and/or Shambhalodging package but are
            experiencing problems logging in.
          </p>
        </div>
      </div>
      <div id="CreateAccountForm" v-if="display_form == 'create'"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner.vue";
import NotificationBanner from "@/components/NotificationBanner.vue";
export default {
  name: "Login",
  components: {
    LoadingSpinner,
		NotificationBanner,
  },
  data() {
    return {
      user: window.portal.user,
      email: "",
      password: "",
      message_display: false,
      message_content: "",
      display_form: "loading",
      forgot_password: false,
      reset_password: false,
      pwr1: "",
      pwr2: "",
      was_reset: false,
      logo: process.env.VUE_APP_LOGO,
      is_sending_reset: false,
    };
  },
  mounted: function () {
    /* #### Mounted Helper Functions #### */
    window.portal.login = this.Login;
    window.portal.logout = this.Logout;
    window.portal.relogin = this.ReLogin;
    this.getLogo()
  },
  methods: {
    getLogo: function () {
      if (window.portal.logo) {
        // Use local logo, not from MS
        //this.logo = window.portal.logo;
      } else {
        setTimeout(() => {
          this.getLogo();
        }, 100);
      }
    },
    Logout() {
      window.portal.session.authenticated = false;
      sessionStorage.removeItem('authenticated');
      window.portal.session.token = "";
      window.portal.clearUser();
      localStorage.setItem("auth-key", "");
      localStorage.removeItem("auth-key");
      localStorage.setItem("auth-user", "");
      localStorage.removeItem("auth-user");
      location.reload();
    },
    Login(e) {
      if (window.params.get("reset") != null) {
        this.ShowReset();
        return
      }
      if (e) {
        e.preventDefault();
      }
      this.display_form = "loading";
      axios.defaults.headers.common["X-Auth-Token"] =
        window.portal.login_secret.encode();
      axios
        .post(`${window.portal.api_server}/userportal/login`, {
          username: this.email.encode(),
          password: this.password.encode(),
        })
        .then((res) => {
          if (res.data.status.success) {
            if (res.data.data.login) {
              let newToken = res.data.data.token.decode().encode();
              if (newToken.length > 0) {
                window.debug("LOGIN SUCCESS");
                window.debug(res.data);
                this.ClearFields();
                window.portal.session.authenticated = true;
                sessionStorage.setItem('authenticated', true);
                window.portal.session.token = newToken;
                localStorage.setItem("auth-key", newToken);
                window.portal.user.id = res.data.data.user_id;
                localStorage.setItem("auth-user", window.portal.user.id);
                this.display_form = "login";
              }
            }
          } else {
            window.debug("LOGIN FAILED");
            window.debug(res.data);
            // Do not display default error message if empty data submitted
            if (this.email != '') {
              this.DisplayErrorMessage(res.data.status.message);
            }
            this.display_form = "login";
          }
        })
        .catch((err) => {
          window.debug("LOGIN AJAX FAILED");
          window.debug(err);
          window.portal.logout();
          this.DisplayErrorMessage("Connection Issue.  Try again in 5min. ⏰");
          this.display_form = "login";
        });
    },
    ReLogin() {
      //if (window.params.get('reset') != null && window.params.get('reset').decode() != '') {
      if (window.params.get("reset") != null) {
        this.ShowReset();
      } else {
        let newToken =
          window.portal.session.token != ""
            ? window.portal.session.token
            : localStorage.getItem("auth-key");
        newToken = newToken ? newToken : "";
        if (newToken != "") {
          newToken = newToken.decode().encode();
        }
        if (newToken != "") {
          axios.defaults.headers.common["X-Auth-Token"] = newToken;
          axios
            .post(`${window.portal.api_server}/userportal/checklogin`, {
              challenge: newToken.decode().encode(),
            })
            .then((res) => {
              if (res.data.status.success) {
                if (res.data.data.challenge.decode() == newToken.decode()) {
                  if (!window.portal.session.authenticated) {
                    window.portal.session.authenticated = true;
                    window.portal.session.token = newToken;
                    localStorage.setItem("auth-key", newToken);
                    let user_id = window.portal.user.id
                      ? window.portal.user.id
                      : localStorage.getItem("auth-user");
                    window.portal.user.id = user_id
                      ? user_id.decode().encode()
                      : null;
                    localStorage.setItem("auth-user", user_id);
                    if (
                      window.portal.user.id == null ||
                      window.portal.user.id == ""
                    ) {
                      window.debug(
                        "[+] login recovered, but no user, forcing logout"
                      );
                      window.portal.logout();
                    } else {
                      window.debug("[+] login recovered");
                    }
                  } else {
                    window.debug("[+] login found");
                  }
                } else {
                  window.portal.logout();
                }
              } else {
                window.debug("[+] login expired");
                window.debug(res.data);
                window.portal.logout();
              }
            })
            .catch((err) => {
              window.debug("[+] login issue");
              window.debug(err);
              window.portal.logout();
            });
        } else {
          window.portal.session.authenticated = false;
          window.portal.session.token = "";
          this.display_form = "login";
        }
      }
    },
    Forgot(e) {
      this.is_sending_reset = true;
      if (e) {
        e.preventDefault();
      }
      this.forgot_password = true;
      axios.defaults.headers.common["X-Auth-Token"] =
        window.portal.forgot_secret.encode();
      axios
        .post(`${window.portal.api_server}/userportal/forgotpassword`, {
          username: this.email.encode(),
        })
        .then((res) => {
          if (res.data.status.success) {
            window.debug("FORGOTTEN PASSWORD EMAIL FOUND");
            window.debug(res.data);
            this.DisplaySuccessMessage(
              "A reset link will be sent to that address if it was found in our system. Please check your spam or junk mail folders if you don't see it."
            );
          } else {
            window.debug("FORGOTTEN PASSWORD EMAIL NOT FOUND");
            window.debug(res.data);
            this.DisplaySuccessMessage(
              "A reset link will be sent to that address if it was found in our system. Please check your spam or junk mail folders if you don't see it."
            );
          }
          this.is_sending_reset = false;
        })
        .catch((err) => {
          window.debug("FORGOTTEN PASSWORD AJAX FAILED");
          window.debug(err);
          this.DisplayErrorMessage("Connection Issue.  Try again in 5min. ⏰");
          this.forgot_password = false;
          this.is_sending_reset = false;
        });
    },
    DisplayErrorMessage(msg) {
      this.message_content = msg;
      this.message_display = "error";
    },
    DisplaySuccessMessage(msg) {
      this.message_content = msg;
      this.message_display = "success";
    },
    ClearMessages() {
      this.message_display = false;
      this.message_content = "";
    },
    ClearFields() {
      this.email = "";
      this.password = "";
      this.pwr1 = "";
      this.pwr2 = "";
      this.was_reset = false;
    },
    ShowForgot(e) {
      if (e) {
        e.preventDefault();
      }
      this.ClearFields();
      this.ClearMessages();
      this.display_form = "forgot";
    },
    ShowReset() {
      //e.preventDefault();
      this.ClearFields();
      this.ClearMessages();
      this.display_form = "reset";
      this.reset_password = false;
      const reset_key = window.params.get("reset")
        ? window.params.get("reset").decode().encode()
        : "".encode();
      axios.defaults.headers.common["X-Auth-Token"] =
        window.portal.show_reset_secret.encode();
      axios
        .post(`${window.portal.api_server}/userportal/resetkeycheck`, {
          key: reset_key,
        })
        .then((res) => {
          if (res.data.status.success) {
            window.debug("RESET KEY FOUND");
            window.debug(res.data);
            this.reset_password = true;
          } else {
            window.debug("RESET KEY NOT FOUND");
            window.debug(res.data);
            this.DisplayErrorMessage(` Reset key was Invalid. Please Try Again.
							<br /><br />
							<strong>Possible Reasons: </strong><br />
							<ul>
							<li>Did you <strong>use the most recent reset email</strong> requested?</li>
							<li>Did you already use the key reset your password?</li>
							<li>Did you copy and paste the link from the email instead of <strong>clicking the link</strong>?</li>
							</ul>
						`);
            this.display_form = "forgot";
          }
        })
        .catch((err) => {
          window.debug("RESET KEYCHECK FAILED");
          window.debug(err);
          this.DisplayErrorMessage("Connection Issue.  Try again in 5min. ⏰");
        });
    },
    ResetPassword(e) {
      if (e) {
        e.preventDefault();
      }
      this.ClearMessages();
      if (this.pwr1 == this.pwr2) {
        if (this.pwr1.length >= 6) {
          this.reset_password = false;
          const reset_key = window.params.get("reset")
            ? window.params.get("reset").decode().encode()
            : "".encode();
          axios.defaults.headers.common["X-Auth-Token"] =
            window.portal.reset_secret.encode();
          axios
            .post(`${window.portal.api_server}/userportal/resetpassword`, {
              key: reset_key,
              k1: this.pwr1.encode(),
              k2: this.pwr2.encode(),
            })
            .then((res) => {
              if (res.data.status.success) {
                window.debug("PASSWORD RESET");
                window.debug(res.data);
                this.reset_password = true;
                this.DisplaySuccessMessage("Password was reset.");
                this.was_reset = true;
              } else {
                window.debug("PASSWORD NOT RESET");
                window.debug(res.data);
                this.DisplayErrorMessage("Password reset failed.");
              }
            })
            .catch((err) => {
              window.debug("PASSWORD RESET FAILED");
              window.debug(err);
              this.DisplayErrorMessage("Password reset failed.");
            });
        } else {
          this.DisplayErrorMessage("Passwords must be at least 6 characters.");
        }
      } else {
        this.DisplayErrorMessage("Passwords must match.");
      }
    },
  },
};
</script>

<style>
#Login {
  --box-padding: 40px;
}
#Login {
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 200;
  background: transparent none;
  display: flex;
  justify-content: center;
  align-items: top;
  text-align: center;
  overflow-x: none;
  overflow-y: auto;
  padding-top: 60px;
}
#Login p {
  position: relative;
  width: 90%;
  max-width: 600px;
  margin: 0 auto;
  text-align: left;
  padding: 20px 0 20px 5%;
}
#Login input {
  width: calc(100% - 10px);
}
#modal-invisible {
  overflow: scroll;
}
#main_logo {
  margin: 0 auto 60px;
  padding: 0 40px;
  max-width: 400px;
  height: auto;
}
#login_box {
  margin-bottom: 35px;
  width: 90%;
  max-width: 500px;
}
#login_box .login-forgot {
  margin: 20px 10px;
  text-align: left;
  font-size: 13px;
}
#Login #LoadingForm {
  margin-top: 100px;
}
.emphasize {
  font-weight: bold;
  text-decoration: none;
  display: inline-block;
  padding: 4px 10px;
  background: rgba(250, 135, 10, 0.4);
}
.emphasize:hover {
  background: rgba(250, 135, 10, 0.9);
  text-decoration-color: #544098;
  text-decoration: underline;
  color: #fff;
}
@media only screen and (max-width: 650px) {
  #Login {
    display: block;
  }
}
</style>
